import { ISelectListItem, View } from "../../Core";
import Vue from "vue";
import { Carousel, Slide } from 'vue-carousel';
import { Uri } from "../../Core/Helpers/Uri";
import * as ajax from "@brightspark/sparkling-ajax-js";
import TimetableFilters from "../../Components/TimetableFilters/TimetableFilters.vue";
import NewsSlider from "../../Components/NewsSlider/NewsSlider.vue";
import MessageSlider from "../../Components/MessageSlider/MessageSlider.vue";
import XelectComponent from "../../Components/Xelect/XelectComponent.vue";


enum Action {
    UpdateFilters,
}

interface IFilters {
    groupLevels: Array<ISelectListItem>;
    groupTypes: Array<ISelectListItem>;
    trainers: Array<ISelectListItem>;
    locations: Array<ISelectListItem>;
}

class ViewDataModel {
    public showGroupLevelsWith: Array<string> = [];
    public groupType: string = "";
    public groupLevel: string = "";
    public trainer: string = "";
    public location: string = "";
}

export class IndexView extends View<IndexView> {
    private _viewData: ViewDataModel = window.__VIEW_DATA;

    public constructor() {
        super();
        this.SetupVue();
    }

    SetupVue() {
        let components = [];

        let v = new Vue({
            el: ".app",
            data: {
                showGroupLevelsWith: this._viewData.showGroupLevelsWith as Array<string>,
                groupLevels: new Array<ISelectListItem>(),
                groupTypes: new Array<ISelectListItem>(),
                trainers: new Array<ISelectListItem>(),
                locations: new Array<ISelectListItem>(),
                groupType: this._viewData.groupType,
                groupLevel: this._viewData.groupLevel,
                trainer: this._viewData.trainer,
                location: this._viewData.location
            },
            mounted() {
                this.change();
            },
            components: {
                //TimetableFilters,
                NewsSlider,
                MessageSlider,
                Carousel,
                Slide,
                XelectComponent
            },
            computed: {
                shouldShowGroupLevels() {
                    var vue = this as any;
                    var index = vue.showGroupLevelsWith.indexOf(vue.groupType.toLowerCase());
                    return index > -1;
                }
            },
            methods: {
                valueChanged(value, component) {
                    var name = component.name;
                    var vue = this as any;
                    if (vue[name] === value) {
                        return;
                    }

                    switch (name) {
                        case "LocationId":
                            vue.location = value;
                            break;
                        case "TrainerId":
                            vue.trainer = value;
                            break;
                        case "GroupTypeId":
                            vue.groupType = value;
                            break;
                        case "GroupLevel":
                            vue.groupLevel = value;
                            break;
                        default:
                            return;
                    }

                    vue.change();
                },
                change() {
                    let vue = this as any;

                    var data = {
                        groupLevel: vue.groupLevel,
                        groupTypeId: vue.groupType,
                        trainerId: vue.trainer,
                        locationId: vue.location
                    }

                    ajax(Uri.getUri(Action[Action.UpdateFilters]), { dataType: "json", method: "post", data: data })
                        .done((res: IFilters) => {
                            if (!res) {
                                return;
                            }

                            this.locations = res.locations;
                            this.groupLevels = res.groupLevels;
                            this.groupTypes = res.groupTypes;
                            this.trainers = res.trainers;
                        });
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/Home/IndexView.ts